import { GetPixPaymentStatus } from '@/store/graphql/queries/westerosArcaneumQueries';
import { MutationTree } from 'vuex';
import { CreditCard, PaymentState, PixData } from './state';

const mutations: MutationTree<PaymentState> = {
  SET_FLAG_OPTIONS(state, flagOptions: string[]) {
    state.flagOptions = flagOptions;
  },
  SET_MONTH_OPTIONS(state, monthOptions: string[]) {
    state.monthOptions = monthOptions;
  },
  SET_YEAR_OPTIONS(state, yearOptions: string[]) {
    state.yearOptions = yearOptions;
  },
  SET_CREDIT_CARD(state, creditCard: CreditCard) {
    state.creditCard = creditCard;
  },
  SET_PAYMENT_VALUE(state, paymentValue: number) {
    state.paymentValue = paymentValue;
  },
  SET_BANK_SLIP_FILE(state, bankSlipFile: string) {
    state.bankSlipFile = bankSlipFile;
  },
  SET_PIX_DATA(state, pixData: PixData) {
    state.pixData = { ...pixData, showPixQrCode: true, isPixCodeExpired: false };
  },
  SET_CURRENT_PAYMENT_METHOD(state, currentPaymentMethod: string) {
    state.currentPaymentMethod = currentPaymentMethod;
  },
  SET_CURRENT_PAYMENT_STATUS(state, currentPaymentStatus: string) {
    state.currentPaymentStatus = currentPaymentStatus;
  },
  SET_CURRENT_PAYMENT_RECURRENT_CREDIT_CARD(state, isRecurrentCreditCard: boolean) {
    state.isRecurrentCreditCard = isRecurrentCreditCard;
  },
  SET_PIX_STATUS(state, { pixCode: payload, isPixCodeExpired }: GetPixPaymentStatus) {
    const pixData: PixData = { payload, showPixQrCode: !isPixCodeExpired, isPixCodeExpired };
    state.pixData = pixData;
  },
  SET_SHOW_PIX_QRCODE(state, { showPixQrCode }: PixData) {
    const pixData: PixData = { ...state.pixData, showPixQrCode };
    state.pixData = pixData;
  },
};

export default mutations;
